import { render, staticRenderFns } from "./Key.vue?vue&type=template&id=83144ff2&scoped=true"
import script from "./Key.vue?vue&type=script&lang=js"
export * from "./Key.vue?vue&type=script&lang=js"
import style0 from "./Key.vue?vue&type=style&index=0&id=83144ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83144ff2",
  null
  
)

export default component.exports